import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fromJS } from 'immutable';
import validatejs from 'validate.js';
import { Col, Row } from 'react-flexbox-grid';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import Delete from 'material-ui/svg-icons/action/delete';

import { Field, FieldArray, formValueSelector, reduxForm, submit } from 'redux-form/immutable';

import { TextField } from 'redux-form-material-ui';

// const formValidation = (values) => validateConstraints(values.toJS(), {
//   "members.email": {
//     presence: {
//       message: "^Bitte wählen Sie ein Preismodel"
//       allowEmpty: false,
//     }
//   }
// });

const validate = values => {
    const errors = {};
    const membersArrayErrors = [];
    const constraints = {
        email: {
            email: {
                message: '^Bitte geben Sie eine gültige E-Mail-Adresse ein',
            },
        },
    };
    const members = values.get('members') || fromJS([]);
    members.forEach((member, memberIndex) => {
        membersArrayErrors[memberIndex] = validatejs(member.toJS(), constraints);
    });
    errors.members = membersArrayErrors;
    return errors;
};

class SubscriptionReceivers extends Component {
    handleSubmit = () => {
        this.props.dispatch(submit('subscriptionReceivers'));
    };

    renderMembers = ({ fields, meta: { touched, error } }) => {
        return (
            <div>
                {fields.map((receiver, index) => (
                    <Row key={index}>
                        <Col xs={3}>
                            <Field
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.props.updateReceivers(
                                            this.props.members.push(fromJS({ email: '' }))
                                        );
                                    }
                                }}
                                floatingLabelText="E-Mail-Adresse"
                                name={`${receiver}.email`}
                                component={TextField}
                                type="text"
                                style={{ width: '100%' }}
                                autoFocus={index === fields.length - 1 ? true : false}
                                label="E-Mail-Adresse"
                            />
                        </Col>
                        <Col xs={3}>
                            <Field
                                floatingLabelText="Gerätename (optionale Angabe)"
                                name={`${receiver}.device_name`}
                                component={TextField}
                                type="text"
                                style={{ width: '100%' }}
                                label="Gerätename"
                            />
                        </Col>
                        {index == fields.length - 1 && (
                            <Col xs={5}>
                                <RaisedButton
                                    label="Weiteres Software-Abos hinzufügen"
                                    style={{ marginTop: '25px' }}
                                    onClick={() =>
                                        this.props.updateReceivers(
                                            this.props.members.push(fromJS({ email: '' }))
                                        )
                                    }
                                />
                            </Col>
                        )}
                        {index !== fields.length - 1 && (
                            <Col xs={4}>
                                <IconButton
                                    tooltip="SVG Icon"
                                    style={{ marginTop: '25px' }}
                                    onClick={() =>
                                        this.props.updateReceivers(this.props.members.delete(index))
                                    }>
                                    <Delete />
                                </IconButton>
                            </Col>
                        )}
                    </Row>
                ))}
            </div>
        );
    };

    render() {
        const { handleSubmit, members } = this.props;

        return (
            <form
                onSubmit={handleSubmit}
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}>
                <div>
                    <h3>Wieviele Software-Abos benötigen Sie?</h3>
                    <p>
                        Bitte geben Sie pro benötigtem Gerät einen Empfänger ein (Empfänger darf für
                        mehrere Geräte identisch sein)
                    </p>
                    <Row>
                        <Col xs={12}>
                            <FieldArray name="members" component={this.renderMembers} />
                        </Col>
                    </Row>
                    <Row>
                        <RaisedButton
                            primary={true}
                            label="Weiter"
                            style={{ marginTop: '25px' }}
                            onClick={this.handleSubmit}
                        />
                    </Row>
                </div>
            </form>
        );
    }
}

const selector = formValueSelector('subscriptionReceivers'); // <-- same as form name

export default connect(state => {
    return {
        members: selector(state, 'members'),
    };
})(
    reduxForm({ form: 'subscriptionReceivers', enableReinitialize: true, validate })(
        SubscriptionReceivers
    )
);
